export const COPPER = 'COPPER'
export const ALUMINIUM = 'ALUMINIUM'
export const UNDEFINED = 'UNDEFINED'
